import { render, staticRenderFns } from "./PollutantsGraphComponent.vue?vue&type=template&id=7b2e67f8"
import script from "./PollutantsGraphComponent.vue?vue&type=script&lang=js"
export * from "./PollutantsGraphComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports